import { InputPdf } from "../file-classes";

const passwordProtected = async ({ pdfOptions: options = {} }, file) => {
    const pdf = new InputPdf(file);
    if (
        pdf.hasValidExtension() &&
        (await pdf.isPasswordProtected()) &&
        !options.allowPasswordProtected
    ) {
        throw new Error("Password protected files are not permitted.");
    }
    return file;
};

const page2Image = async ({ pdfOptions: options = {} }, file) => {
    const pdf = new InputPdf(file);
    if (options.convert && pdf.hasValidExtension()) {
        const page = await pdf.pageImage(1);
        return page;
    }
    return file;
};

export { page2Image, passwordProtected };
